<div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>  

<div *ngIf="!isLoading">
    <div>
        <mat-form-field appearance="fill" style="display: inline">
            <mat-label>Suche</mat-label>
            <input type="text" matInput name="search" [(ngModel)]="search" (keydown.enter)="onSearch()">
            <button matSuffix mat-icon-button (click)="onSearch()"><mat-icon>search</mat-icon></button>
            <button *ngIf="search" matPrefix mat-icon-button aria-label="Clear" (click)="search='';onSearch()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <mat-accordion>
        <mat-expansion-panel [expanded]="isExpanded"  class="mat-elevation-z0 navBox">
            <mat-expansion-panel-header>
                <mat-panel-title class="mt-2">
                    <h6>{{ title }}</h6>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-selection-list #navData [multiple]="false" [(ngModel)]="selOption" (ngModelChange)="onNgModelchange($event)">
                    <div class="content-container class_maxheight500" fxLayout="column" fxLayoutAlign="stretch" fxFlex="auto">
                    <perfect-scrollbar class="scroll-container" fxFlex="auto" [config]="config" [scrollIndicators]="true" style="max-height: 200px;">
                        <div class="scrollable-content">
                            <mat-list-option *ngFor="let d of reihenfolgeTree" [value]="d" class="no-wrap" matTooltip="{{d[displayPath]}}">
                                <span style="font-size: 1.2rem;" class="my-1">
                                    <span *ngIf="isCategorySelected && d.id === selOption[0].id">
                                        <button mat-icon-button color="warn" aria-label="clear-selected-catagory" (click)="clearCategoryFilter();selOption=null;$event.stopPropagation()">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                    </span> {{d[displayPath]}}
                                </span>
                            </mat-list-option>
                        </div>
                    </perfect-scrollbar>
                </div>
            </mat-selection-list>
        </mat-expansion-panel>
    </mat-accordion>
</div>



<!-- <div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>  

<div *ngIf="!isLoading">
    <kkis-app-webshop-nav-box1 [title]="title" [data]="reihenfolgeTree" [minPreis]="minPreis" [maxPreis]="maxPreis" [displayPath]="displayPath" [valuePath]="valuePath" [isExpanded]="isTopLevelNavExpanded" (selectedOption)="getSelectedOption($event)"></kkis-app-webshop-nav-box1>
</div> -->